import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface SetMarkAsReadParams {
  notificationId: string; // The ID of the notification to mark as read
}

export interface MarkAsReadResponse {
  success: boolean;
  data: {
    id: string; // The ID of the notification that was marked as read
    isRead: boolean; // The new read status of the notification
    updatedAt: string; // The timestamp when the notification was updated
  };
}

const markAsRead: MutationFunction<boolean, SetMarkAsReadParams> = async (
  args,
) => {
  if (isMockServices()) return (await mock(_mockType)).success;

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<MarkAsReadResponse>(
    `/users/me/notifications/${args.notificationId}/read`,
    {
      method: 'PUT',
    },
  );
  if (response.data) return response.data.success;

  throw new Error('Failed to update notification status');
};

export default markAsRead;

const _mockType = {
  success: true,
};
